import { render, staticRenderFns } from "./MyDialog.vue?vue&type=template&id=01e6b06b&scoped=true"
import script from "./MyDialog.vue?vue&type=script&lang=js"
export * from "./MyDialog.vue?vue&type=script&lang=js"
import style0 from "./MyDialog.vue?vue&type=style&index=0&id=01e6b06b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6b06b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01e6b06b')) {
      api.createRecord('01e6b06b', component.options)
    } else {
      api.reload('01e6b06b', component.options)
    }
    module.hot.accept("./MyDialog.vue?vue&type=template&id=01e6b06b&scoped=true", function () {
      api.rerender('01e6b06b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/MyDialog.vue"
export default component.exports